import localStorageUser from './localStorageUser';

export const setBusinessOrganizationInStorage = organization => {
  const currentUserId = localStorageUser.getCurrentUserId();
  if (currentUserId) {
    localStorageUser.addRecentlyViewedOrganization(currentUserId, organization);
  }
  localStorageUser.setBusinessOrganizationLocalStorage(organization);
  localStorageUser.setUserStore({});
};
